import MyAccountToggle from "../MyAccountToggle"

type Props = {
    value: boolean;
    onChange: (checked: boolean) => void;
}

const PresentationModeToggle = (props: Props) => {
    return <MyAccountToggle
        label='Open projects in Presentation Mode by default'
        checked={props.value}
        tooltipContent={<PresentationModeToggleTooltipContent />}
        onChange={(e, v) => props.onChange(!!v)}
    />
}

export const PresentationModeToggleTooltipContent = () => <div className="content">
    In Presentation Mode, a Power BI report or a Project Story will be displayed in place of the corresponding Dashboard.
    <br />
    <br />
    NOTE: if you have Edit permissions to the project, a Project Dashboard will be opened for this project regardless the setting state. 
    <br />
    <br />
    <span>Please refer to <a href='https://help.ppm.express/94162-portfolio-and-project-management/project-presentation-mode' target='_blank'>this</a> article</span>
</div >

export default PresentationModeToggle;
